var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBedtime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.2 34",
    style: {
      enableBackground: "new 0 0 31.2 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CADDD9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_209_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_210_",
    className: "st0",
    d: "M31,25.4c-0.3-0.7-1-1.2-1.8-1.2c-4.6-0.3-8.7-3.2-10.7-7.3C17.6,15,17.1,13,17.1,11 c0-2.7,0.8-5.3,2.4-7.5C20,2.8,20,2,19.7,1.3c-0.3-0.7-1-1.2-1.8-1.2C17.5,0,17.1,0,16.6,0C7.1,0,0,7.4,0,17c0,9.6,7.1,17,16.6,17 c5.6,0,10.9-1.8,14.2-6.5C31.2,26.9,31.3,26.1,31,25.4z M17.1,31C9.3,31,3,25.7,3,17.9C3,8.6,8.6,4.3,16,3c-0.9,2.2-2,4.6-2,7 c0,2.9,0.7,6.4,2,9c2.3,4.6,6.2,6.5,11,8C24.5,29.1,20.4,31,17.1,31z M8.2,9.3c-2.7,2.3-3.8,5.8-2.8,9c0.2,0.5,0.8,0.8,1.4,0.6 c0.6-0.2,0.9-0.8,0.7-1.3c-0.8-2.4,0.1-5.1,2.1-6.9c0.2-0.2,0.3-0.4,0.4-0.7c0-0.3,0-0.6-0.3-0.8C9.3,8.9,8.6,8.9,8.2,9.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedtime);
export default __webpack_public_path__ + "static/media/bedtime.39d89bc639445b4d3451b47b8e78c544.svg";
export { ForwardRef as ReactComponent };